module.exports = __webpack_public_path__ + "1863f5c67a428137f92f326da015c5d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/tesla_2023_chart.png
// module id = 1734
// module chunks = 0